// extracted by mini-css-extract-plugin
export default {"updateConfirmationContainer":"UserUpdateConfirmation_updateConfirmationContainer__zJWBK","updateTitle":"UserUpdateConfirmation_updateTitle__X1W4F"};